export default function createPasswordProtectionReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_PASSWORD-PROTECTION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_PASSWORD-PROTECTION_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_PASSWORD-PROTECTION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}